import {
  SAVE_DASHBOARD_CHECKBOXES_VALUES,
  SAVE_HISTORY_CHECKBOXES_VALUES
} from "../constants/dashboard";

const initialState = {
  dashboardCheckboxes: {
    today: false,
    thisWeek: false,
    startDate: null,
    endDate: null
  },
  historyCheckboxes: {
    today: false,
    thisWeek: false,
    startDate: null,
    endDate: null
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_DASHBOARD_CHECKBOXES_VALUES:
      return {
        ...state,
        dashboardCheckboxes: {
          today: action.payload.today,
          thisWeek: action.payload.thisWeek,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      };
    case SAVE_HISTORY_CHECKBOXES_VALUES:
      return {
        ...state,
        historyCheckboxes: {
          today: action.payload.today,
          thisWeek: action.payload.thisWeek,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      };
    default:
      return state;
  }
}
